$('.fil-comparison-list [data-equalizer]').trigger('resizeme.zf.trigger');
